import { ClientApplicationConfig } from '@monorepo/types';
import { useStore } from '@hub/helpers/use-store';
import {
  QUERY_CONFIGS,
  QueryConfigKeys,
} from '@hub/utils/react-query/query-config';
import { fetchApplicationConfig } from '@hub/utils/react-query/query-functions';
import { QUERY_KEYS } from '@hub/utils/react-query/query-keys';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

const CONFIG_KEY = QueryConfigKeys.APP_CONFIG;

// This function can be exported and reused in both the hook and in useAppInitialization
export const getApplicationConfigQueryOptions = (): UseQueryOptions<
  ClientApplicationConfig,
  Error,
  ClientApplicationConfig
> => {
  return {
    queryKey: QUERY_KEYS[CONFIG_KEY].CONFIG,
    queryFn: fetchApplicationConfig,
    staleTime: QUERY_CONFIGS[CONFIG_KEY].staleTime,
  };
};

export const useApplicationConfig = () => {
  const {
    dataStore: { applicationConfigStore },
  } = useStore();

  return useQuery<ClientApplicationConfig, Error, ClientApplicationConfig>({
    ...getApplicationConfigQueryOptions(),
    meta: {
      onSuccess: (appConfig: ClientApplicationConfig) => {
        // This update happens from the hook
        applicationConfigStore.updateFromApiResponse(appConfig);
      },
    },
  });
};
